import { render, staticRenderFns } from "./myFilterModel.vue?vue&type=template&id=2b2b5ef5&scoped=true&"
import script from "./myFilterModel.vue?vue&type=script&lang=js&"
export * from "./myFilterModel.vue?vue&type=script&lang=js&"
import style0 from "./myFilterModel.vue?vue&type=style&index=0&id=2b2b5ef5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b5ef5",
  null
  
)

export default component.exports